import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=228f651a&scoped=true"
import script from "./ContactDialog.vue?vue&type=script&lang=ts"
export * from "./ContactDialog.vue?vue&type=script&lang=ts"
import style0 from "./ContactDialog.vue?vue&type=style&index=0&id=228f651a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f651a",
  null
  
)

export default component.exports